import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
import { CSSTransition } from "react-transition-group"; //Material imports

import SwipeableViews from "react-swipeable-views";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Fullscreen from "@material-ui/icons/Fullscreen";
import Close from "@material-ui/icons/Close"; //Limitless imports

import { withi18n } from "../../hocs/i18n";
import UserAvatar from "../../user-avatar/UserAvatar";
import TimePosted from "../../time-posted/TimePosted";
import DialogueBody from "../../dialogue-body/DialogueBody";
var wordCount = 170;

var SuggestedAnswerDialogueCarousel = /*#__PURE__*/function (_PureComponent) {
  _inherits(SuggestedAnswerDialogueCarousel, _PureComponent);

  var _super = _createSuper(SuggestedAnswerDialogueCarousel);

  function SuggestedAnswerDialogueCarousel() {
    var _this;

    _classCallCheck(this, SuggestedAnswerDialogueCarousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      value: 0,
      fullScreen: false,
      currentAnswer: {}
    };

    _this.truncate = function (body) {
      if (body.length < wordCount) {
        return body;
      }

      var subString = body.substr(0, wordCount - 1);
      return "".concat(subString.substr(0, subString.lastIndexOf(" ")), "...");
    };

    _this.formatConfidence = function (answer) {
      return Math.round(answer.suggestedAnswerScore * 100);
    };

    _this.renderAnswers = function () {
      var _this$props = _this.props,
          suggestedAnswers = _this$props.dialogue.suggestedAnswers,
          theme = _this$props.theme,
          classes = _this$props.classes;
      var fullScreen = _this.state.fullScreen;
      return suggestedAnswers.map(function (answer, index) {
        return /*#__PURE__*/React.createElement("div", {
          id: "sa-".concat(index + 1),
          className: classes.responseListItem,
          key: index,
          ref: function ref(el) {
            return _this.swipeableView = el;
          }
        }, fullScreen ? /*#__PURE__*/React.createElement(DialogueBody, {
          body: answer.body,
          textStyling: classes.secondaryText
        }) : /*#__PURE__*/React.createElement(Typography, {
          dir: theme.direction,
          key: index,
          className: "".concat(classes.secondaryText),
          component: "span",
          tabIndex: "0"
        }, _this.truncate(answer.body)));
      });
    };

    _this.renderTabs = function () {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          dialogue = _this$props2.dialogue;
      var tabIndex = 0;
      var tabs = [];
      dialogue.suggestedAnswers.map(function () {
        tabIndex++;
        tabs.push( /*#__PURE__*/React.createElement(Tab, {
          id: "saDot-".concat(tabIndex),
          key: tabIndex,
          classes: {
            root: classes.indicator
          },
          component: "div"
        }));
      });
      return tabs;
    };

    _this.renderAvatar = function () {
      var _this$props3 = _this.props,
          dialogue = _this$props3.dialogue,
          message = _this$props3.message;
      var expertInfo = message.expertAuthors[dialogue.userId];
      return /*#__PURE__*/React.createElement(UserAvatar, {
        thumbnail: expertInfo ? expertInfo.thumbnail : null,
        author: dialogue.author
      });
    };

    _this.handleChange = function (event, value) {
      _this.setState({
        value: value,
        currentAnswer: _this.props.dialogue.suggestedAnswers[value]
      });

      var selectedDialogueId = _this.props.dialogue.suggestedAnswers[value].dialogueId;

      _this.props.handleSuggestedAnswerSelection(selectedDialogueId);
    };

    _this.handleChangeIndex = function (index) {
      _this.setState({
        value: index,
        currentAnswer: _this.props.dialogue.suggestedAnswers[index]
      });
    };

    _this.handleClick = function () {
      _this.setState({
        fullScreen: !_this.state.fullScreen
      });

      _this.props.handleFullScreen(_this.state.fullScreen);
    };

    return _this;
  }

  _createClass(SuggestedAnswerDialogueCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.dialogue.suggestedAnswers) {
        this.props.handleSuggestedAnswerSelection(this.props.dialogue.suggestedAnswers[0].dialogueId);
        this.setState({
          currentAnswer: this.props.dialogue.suggestedAnswers[0]
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          _this$props4$dialogue = _this$props4.dialogue,
          created = _this$props4$dialogue.created,
          suggestedAnswers = _this$props4$dialogue.suggestedAnswers,
          theme = _this$props4.theme,
          classes = _this$props4.classes,
          t = _this$props4.t,
          unmount = _this$props4.unmount,
          logger = _this$props4.logger;
      var _this$state = this.state,
          fullScreen = _this$state.fullScreen,
          currentAnswer = _this$state.currentAnswer;
      var moreThanOneSA = suggestedAnswers.length >= 2; // for any reason suggested answers is not available, return a div.

      if (!suggestedAnswers) {
        return /*#__PURE__*/React.createElement("div", null);
      } //TODO refactor this mess so it's 2 components, 1 fullscreen and one normal


      logger.debug("".concat(suggestedAnswers.length, " SAs"));
      return /*#__PURE__*/React.createElement(CSSTransition, {
        in: !unmount,
        timeout: 300,
        unmountOnExit: true,
        classNames: {
          exit: classes.fadeExit,
          exitActive: classes.fadeExitActive
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.saContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement("div", null, this.renderAvatar()), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.responseWrapper, " ").concat(classes.secondaryBackground, " ").concat(fullScreen ? classes.fullScreen : "")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.header, " ").concat(fullScreen && classes.fullScreenHeader),
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.headerFiller
      }), /*#__PURE__*/React.createElement(Typography, {
        color: "inherit",
        classes: {
          root: classes.titleRoot
        },
        align: "center",
        tabIndex: "0"
      }, t("Previous Answers Given")), fullScreen ? /*#__PURE__*/React.createElement(Close, {
        className: "".concat(classes.secondaryText, " ").concat(classes.headerIcon)
      }) : /*#__PURE__*/React.createElement(Fullscreen, {
        className: "".concat(classes.secondaryText, " ").concat(classes.headerIcon),
        tabIndex: "0"
      })), /*#__PURE__*/React.createElement(SwipeableViews, {
        axis: theme.direction === "rtl" ? "x-reverse" : "x",
        index: this.state.value,
        onChangeIndex: this.handleChangeIndex,
        style: fullScreen ? {
          height: 500
        } : {
          overflowY: "hidden"
        },
        onClick: this.handleClick,
        containerStyle: {
          height: "100%"
        },
        slideStyle: fullScreen ? {} : {
          overflow: "hidden"
        }
      }, this.renderAnswers()), /*#__PURE__*/React.createElement("div", {
        className: classes.confidenceContainer,
        style: !moreThanOneSA ? {
          paddingBottom: 5
        } : {}
      }, currentAnswer && currentAnswer.suggestedAnswerScore && /*#__PURE__*/React.createElement(Typography, {
        className: classes.confidenceText,
        variant: "caption"
      }, t("{0}% confidence", this.formatConfidence(currentAnswer)))), moreThanOneSA && /*#__PURE__*/React.createElement(Tabs, {
        value: this.state.value,
        onChange: this.handleChange,
        indicatorColor: "secondary",
        textColor: "secondary",
        centered: true,
        classes: {
          root: classes.paperRoot,
          flexContainer: classes.tabFlexContainer,
          indicator: classes.activeIndicator
        },
        component: "div",
        TabIndicatorProps: {
          classes: {
            root: "".concat(fullScreen ? classes.fulllScreenActiveIndicatorBottom : classes.activeIndicatorBottom)
          }
        }
      }, this.renderTabs()))), /*#__PURE__*/React.createElement("div", {
        className: classes.responseTime
      }, /*#__PURE__*/React.createElement(TimePosted, {
        time: created
      }))));
    }
  }]);

  return SuggestedAnswerDialogueCarousel;
}(PureComponent);

var styles = function styles(_ref) {
  var _palette$dialogues$su, _palette$dialogues, _palette$dialogues$su2, _palette$dialogues$su3, _palette$dialogues2, _palette$dialogues2$s, _palette$dialogues$su4, _palette$dialogues3, _palette$dialogues3$s, _palette$dialogues$su5, _palette$dialogues4, _palette$dialogues4$s;

  var palette = _ref.palette;
  var light = (_palette$dialogues$su = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$su2 = _palette$dialogues.suggestedAnswer) === null || _palette$dialogues$su2 === void 0 ? void 0 : _palette$dialogues$su2.background) !== null && _palette$dialogues$su !== void 0 ? _palette$dialogues$su : palette.secondary.light;
  var dark = (_palette$dialogues$su3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$s = _palette$dialogues2.suggestedAnswer) === null || _palette$dialogues2$s === void 0 ? void 0 : _palette$dialogues2$s.text) !== null && _palette$dialogues$su3 !== void 0 ? _palette$dialogues$su3 : palette.secondary.dark;
  var main = (_palette$dialogues$su4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$s = _palette$dialogues3.suggestedAnswer) === null || _palette$dialogues3$s === void 0 ? void 0 : _palette$dialogues3$s.background) !== null && _palette$dialogues$su4 !== void 0 ? _palette$dialogues$su4 : palette.secondary.main;
  var borderRadius = (_palette$dialogues$su5 = (_palette$dialogues4 = palette.dialogues) === null || _palette$dialogues4 === void 0 ? void 0 : (_palette$dialogues4$s = _palette$dialogues4.suggestedAnswer) === null || _palette$dialogues4$s === void 0 ? void 0 : _palette$dialogues4$s.borderRadius) !== null && _palette$dialogues$su5 !== void 0 ? _palette$dialogues$su5 : 12;
  return {
    saContainer: {
      paddingTop: 10,
      paddingBottom: 10
    },
    header: {
      borderBottom: "solid 1px",
      borderBottomColor: dark,
      color: dark,
      display: "flex",
      justifyContent: "space-between",
      minHeight: 35
    },
    headerFiller: {
      height: 20,
      width: 20
    },
    "@media screen and (min-width: 450px)": {
      fullScreenHeader: {
        height: 65
      }
    },
    titleRoot: {
      padding: "8px"
    },
    headerIcon: {
      size: 12,
      paddingTop: 5,
      paddingRight: 10
    },
    secondaryBackground: {
      backgroundColor: main
    },
    secondaryText: {
      color: dark
    },
    author: {
      paddingLeft: 10,
      paddingTop: 3,
      borderTop: "solid 1px",
      borderTopColor: dark
    },
    paperRoot: {
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      backgroundColor: main,
      minHeight: 22,
      marginBottom: 3,
      boxShadow: "none",
      display: "flex",
      justifyContent: "center"
    },
    indicator: {
      minWidth: 0,
      margin: 5,
      height: 14,
      width: 14,
      borderRadius: "50%",
      minHeight: 12,
      //for IE11,
      padding: 0,
      backgroundColor: light,
      border: "0.5px solid ".concat(dark)
    },
    activeIndicator: {
      backgroundColor: dark,
      height: 14,
      width: 14,
      borderRadius: "50%",
      padding: 0
    },
    tabFlexContainer: {
      width: 230,
      margin: "auto",
      justifyContent: "center"
    },
    fulllScreenActiveIndicatorBottom: {
      bottom: 2
    },
    activeIndicatorBottom: {
      bottom: 5
    },
    listItem: {
      display: "flex",
      flex: 1,
      flexDirection: "row",
      width: "85%",
      marginLeft: 5
    },
    responseWrapper: {
      flex: 1,
      marginLeft: 5,
      marginRight: 5,
      position: "relative",
      borderRadius: borderRadius,
      flexDirection: "column",
      cursor: "pointer",
      maxWidth: "85%",
      "-webkit-tap-highlight-color": "transparent"
    },
    responseListItem: {
      display: "flex",
      flex: 1,
      padding: "10px 10px 0px 10px",
      flexDirection: "column"
    },
    confidenceContainer: {
      display: "flex",
      flex: 1,
      justifyContent: "flex-end",
      alignItems: "flex-end",
      minHeight: 20,
      paddingRight: 10
    },
    confidenceText: {
      color: dark,
      fontWeight: "600 !important"
    },
    fullScreen: {
      position: "absolute",
      padding: 0,
      margin: 0,
      right: 0,
      top: 0,
      left: 0,
      height: "100%",
      flex: 1,
      borderRadius: 0,
      maxWidth: "100%",
      display: "flex"
    },
    responseTime: {
      display: "flex",
      flex: 1,
      width: "85%",
      justifyContent: "flex-end",
      paddingTop: 5
    },
    fadeExit: {
      opacity: 1
    },
    fadeExitActive: {
      opacity: 0,
      transition: "all 300ms ease-in"
    }
  };
};

export default withStyles(styles, {
  withTheme: true
})(withi18n(SuggestedAnswerDialogueCarousel, "Suggested Answers Carousel"));